import { InferType, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { currencyIdSchema, safeString } from './common';

interface PortalFiatWithdrawalSchemaParams {}

export const portalFiatWithdrawalSchema = (params: PortalFiatWithdrawalSchemaParams) => {
    return object({
        currencyId: currencyIdSchema('Withdrawal Currency cannot be empty!'),
        bankInfoId: object({ label: safeString(), value: number() }).required('Please select a bank account.'),
        // amount value must be greater than 0
        amount: safeString()
            .test('amount', 'Amount must be more than 0', (value) => {
                return parseFloat(value || '0') > 0;
            })
            .required('Amount cannot be empty!'),
        requestDescription: safeString()
    });
};

export type PortalFiatWithdrawalFormValues = InferType<ReturnType<typeof portalFiatWithdrawalSchema>>;
export type PortalFiatWithdrawalFormInput = Nullable<PortalFiatWithdrawalFormValues>;
